/* globals  jui, lp */
var jQuery = require('jquery');
var _ = require('lodash');

(function(){
  var _propertyTypes = [ "bgColor", "opacity", "fitWidthToPage", "baseColor"
    , "fromColor", "toColor", "autoGradient", "reverseGradient"
    , "image", "parallax", "fitToContainer", "position"
    , "isColorOverImage", "tiling", "videoId", "videoUrl", "videoRatio", "videoImage", "videoHost"];

  var onfocus = function(e) {
    // TODO: Fix that this requires a full object passed through
    window.editor.keyController.requestFocus(e.data, this);
  };

  var mkOnChangeHandler = function(onchange, property, skipRedraw) {
    return function(ev) {
      onchange({type: 'setProperty', property: property, value: ev.data, skipRedraw: skipRedraw});
    };
  };

  var mkColorPicker = function(label, property, onchange, colorValue) {
    var picker = new jui.FormColorInput({
      classNames : ['top-cap'],
      label: label,
      onfocus: onfocus,
      onblur: function(ev) {
        //Don't laugh, the setTimeout is important. The reason we are
        //doing this is because we need to assure that the onchange
        //happens after the onblur is complete otherwise we get issues
        //as the bg color fields get redrawn as the style drop-down is
        //being drawn.
        window.setTimeout(function(){
          onchange({
            type: 'setProperty',
            property: property,
            value: ev.source.getValue(),
            skipRedraw: false
          });
        }, 25);
      }
    });
    if (colorValue) {
      picker.setValue(colorValue);
    }
    return picker;
  };

  var _openImageChooser = function(onchange, onCancel) {
    window.editor.openAssetLibrary({
      onlyImages: true,
      onChoose: function(image) {
        jQuery('<img />')
          .attr('src', image.content_url)
          .load(function(){
            image.size = {width: this.width, height: this.height};
            onchange({property: 'image', value: image});
          });
      },
      onCancel: onCancel || _.noop
    });
  };

  var mkBGImageChooser = function(onchange) {
    return new jui.FormAssetChooser({
      attributes: {
        className: "form-elm asset-chooser top-cap"
      },
      label: 'Image Source',
      noFileText: 'No image specified',
      changeAction: function() {
        _openImageChooser(onchange);
      },
    });
  };

  var mkOpacity = function(onchange) {
    var um = window.editor.page.undoManager;
    return new jui.FormSliderInput({
      label: 'Opacity',
      slider: {min: 0, max: 100, increment: 1},
      onfocus: onfocus,
      onchange: mkOnChangeHandler(onchange, 'opacity', true),
      startTracking: function() {um.startGroup();},
      stopTracking: function(/*ev*/) {
        // TODO skip undo registration of the intermediate steps and
        // only register the starting and final values
        // onchange({type:
        // 'opacity',
        //           value: ev.source.getValue()*100,
        //           finalValue: true,
        //           skipRedraw: true});
        um.endGroup();
      }});
  };

  var mkPositionControl = function(onchange) {
    return new jui.FormAlignSelect ({
      label: 'Position',
      action: mkOnChangeHandler(onchange, 'position', true)
    });
  };

  var mkAdvancedContainer = function(container, element, onchange) {
    var advanced;

    var advancedToggle = jQuery('<div class="bg-panel-advanced"><i class="fa collapse-icon"></i>Advanced Settings</div>')
      .addClass( element.showAdvanced ? 'advanced-panel-open' : '')
      .on('click', function() {
        onchange({
          type: 'toggleAdvancedBackgroundProperties',
          skipRedraw: true
        });
      });

    container.insert(advancedToggle[0]);

    advanced = container.insert(new jui.Component({classNames: ["advanced-bg-props-container"]}));
    return advanced;
  };

  var mkFormatGroup = function() {
    var format = new jui.Component({attributes: {className: 'form-elm format top-cap'}});
    format.insert(jQuery('<label class="form-elm-label">Format</label>')[0]);
    return format;
  };

  var mkFitWidthToPage = function(onchange, props) {
    var el = (new jui.FormCheckboxInput({
      attributes: {className: 'right with-label checkbox-input'},
      inputId: 'fit-width-to-page-checkbox',
      label: 'Stretch background to page edges',
      onclick: mkOnChangeHandler(onchange, 'fitWidthToPage', true)
    }));
    el.setValue(props.fitWidthToPage);
    return el;
  };

  var mkColourControls = function(element, onchange, props) {
    var colorProperties = new jui.Component({attributes: {className: 'form-elm align-select color-overlay-container'}});

    var label = props.style === 'video' ? 'Color Overlay' : 'Color';
    colorProperties.insert(jQuery('<label class="color-overlay-label form-elm-label">' + label + '</label>')[0]);

    var color = colorProperties.insert(mkColorPicker('', 'bgColor', onchange));
    color.setValue(props.bgColor);

    if (element.type !== 'lp-pom-text' && props.style !== 'video') {
      // Text boxes support colour underlays for backwards compatibility. However, we hide
      // the overlay/underlay switcher control to prevent the user from using a colour
      // overlay instead. Video backgrounds support overlays but not underlays so the
      // control is also hidden.
      var overUnder = colorProperties.insert(
          new jui.Component({
              attributes:{
                className: 'radio-btn-grp'
              }
            }));

      var over = overUnder.insert(new jui.FormRadioInput({
        label: 'Overlay',
        attributes: {className: 'radio-input'},
        inputId: 'overlay-radio',
        onclick: function() {
          under.setValue(false);
          onchange({property: 'isColorOverImage', value: true, skipRedraw: true});
        }
      }));
      var under = overUnder.insert(new jui.FormRadioInput({
        label: 'Underlay',
        attributes: {className: 'radio-input'},
        inputId: 'underlay-radio',
        onclick: function() {
          over.setValue(false);
          onchange({property: 'isColorOverImage', value: false, skipRedraw: true});
        }
      }));
      over.setValue(props.isColorOverImage);
      under.setValue( ! props.isColorOverImage);
    }

    colorProperties.insert(mkOpacity(onchange)).setValue(props.opacity);

    return colorProperties;
  };

  var shouldInsertFitWidthToPageControl = function(element) {
    return element.type === 'lp-pom-block' && element.page.allowFitWidthToPage();
  };

  //////////////////////////////////////////////////////////////////////
  var bgControlRenderers = {};
  bgControlRenderers.solidColor = function(parent, props, onchange, element) {
    var container = parent;
    container.insert(mkColorPicker('Color', 'bgColor', onchange, props.bgColor));
    container.insert(mkOpacity(onchange)).setValue(props.opacity);

    if (shouldInsertFitWidthToPageControl(element)) {
      container.insert(mkFitWidthToPage(onchange, props));
    }
  };


  bgControlRenderers.gradient = function(parent, props, onchange, element) {
    var container = parent;
    var baseColor = container.insert(mkColorPicker('Base Color', 'baseColor', onchange));
    baseColor.setValue(props.baseColor);
    baseColor.setEnabled(props.autoGradient);

    var fromColor = container.insert(mkColorPicker('Top', 'fromColor', onchange));
    fromColor.setValue(props.fromColor);
    fromColor.setEnabled(!props.autoGradient);

    var gradientButtonContainer = new jui.Component({
      attributes: {
        className: 'gradient-button-wrap'
      }
    });

    var reverseButton = new jui.ToggleButton({
      classNames: ['reverse-gradient', 'svg-ico-reverse-icon'],
      toolTip: 'Swap gradient colors',
      action: mkOnChangeHandler(onchange, 'reverseGradient')
    });

    var lockButton = new jui.ToggleButton({
      classNames: ['lock-gradient', 'svg-ico-lock-locked-2'],
      toolTip: 'Customize gradient colors',
      action: function(e) {
        onchange({property : 'autoGradient', value: !e.source.isOn()});
      }
    });

    gradientButtonContainer.insert(reverseButton);
    gradientButtonContainer.insert(lockButton).setSelected(!props.autoGradient);

    fromColor.insert(gradientButtonContainer);

    var toColor = container.insert(mkColorPicker('Bottom', 'toColor', onchange));
    toColor.setValue(props.toColor);
    toColor.setEnabled(!props.autoGradient);

    if (shouldInsertFitWidthToPageControl(element)) {
      var format = container.insert(mkFormatGroup());
      format.insert(mkFitWidthToPage(onchange, props));
    }
  };

  var renderImageOrPattern = function(style, parent, props, onchange, element) {
    var container = parent;

    var image = container.insert(mkBGImageChooser(onchange));
    if (props.image) {
      image.setAsset(props.image);
    } else {
      image.setAsset(null);
    }

    if (element.defaultConstraints.parallaxable && window.editor.page.allowParallax()) {
      container.insert(new jui.FormCheckboxInput({
        label: 'Parallax Effect',
        inputId: 'parallax-checkbox',
        attributes: {
          className: "form-elm checkbox-input-parallax top-cap"
        },
        onclick: mkOnChangeHandler(onchange, 'parallax', true)
      })).setValue(props.parallax);
    }

    if ((style === 'pattern' || style === 'image') && shouldInsertFitWidthToPageControl(element)) {
      container.insert(mkFitWidthToPage(onchange, props));
    }

    if (style === 'image') {
      container.insert(new jui.FormCheckboxInput({
        attributes: {className: 'right with-label checkbox-input'},
        label: 'Fit background to container',
        inputId: 'fit-to-container-checkbox',
        onclick: mkOnChangeHandler(onchange, 'fitToContainer')
      })).setValue(props.fitToContainer);
    }

    var advanced = mkAdvancedContainer(container, element, onchange);

    advanced.insert(mkPositionControl(onchange)).setValue(props.position);

    if (style === 'pattern') {
      advanced.insert( new jui.FormSelect ({
        label: 'Tiling',
        width: '100px',
        id: 'jui-background-repeat-select',
        dropDownClassName : 'editor-info-panel-select jui-drop-down',
        selectOptions: [
          //{name:'none',value:'no-repeat'},
          {name:'both', value:'repeat'},
          {name:'horizontal', value:'repeat-x'},
          {name:'vertical', value:'repeat-y'}
        ],
        action: mkOnChangeHandler(onchange, 'tiling', true)
      })).select.setValue(props.tiling);
    }

    //////////////////////////////////////////////////////////////////////

    advanced.insert(mkColourControls(element, onchange, props));

    //////////////////////////////////////////////////////////////////////

    // must be hidden after the opacity is drawn
    if (! element.showAdvanced) {
      advanced.hide();
    }
  };

  bgControlRenderers.image = function(parent, props, onchange, element) {
    renderImageOrPattern('image', parent, props, onchange, element);
  };

  bgControlRenderers.pattern = function(parent, props, onchange, element) {
    renderImageOrPattern('pattern', parent, props, onchange, element);
  };

  bgControlRenderers.video = function(parent, props, onchange, element) {
    var container = parent;
    container.insert(new jui.FormTextInput({
      attributes: {className: 'form-elm text-input video-url'},
      label  : 'Video URL',
      onblur : function(e) {
        onchange({
          type       : 'setProperty',
          property   : 'videoUrl',
          value      : e.source.getValue(),
          skipRedraw : true
        });
      },
      onfocus: onfocus
    }).setValue(props.videoUrl || ''));

    if (shouldInsertFitWidthToPageControl(element)) {
      container.insert(mkFitWidthToPage(onchange, props));
    }

    var advanced = mkAdvancedContainer(container, element, onchange);
    advanced.insert(mkColourControls(element, onchange, props));

    if (! element.showAdvanced) {
      advanced.hide();
    }
  };

  //////////////////////////////////////////////////////////////////////

  lp.editor.panel = lp.editor.panel || {};
  lp.editor.panel.ElementBackgroundControlsNew = {
    installBackgroundControls: function(options) {
      this._bgUIBinding = this._uiBinding.mkNamespacedVersion('background');

      var insert = options.insert || this.insert.bind(this);
      var backgroundPropsContainer = insert(new jui.Component({attributes: {className: 'bg-props-container'}}));
      this.controls.backgroundPropsContainer = backgroundPropsContainer;
      // redraw the panel section for any model changes that was NOT triggered from this UI
      // i.e. undo / redo triggered model changes
      var self = this;
      this._changingBackground = false;
      this.um = window.editor.page.undoManager;

      lp.pom.NewBGPropsHelper
        .changeEvents.ub_subscribe(function(e) {
          var element = e.model.element;
          if ( ! (element === window.editor.activeElement &&
                element.type === self.getModule().type)) {
            // short-circuit if not on the right singleton
            return;
          }

          if (!self._changingBackground) {
            // this does not seem to be necessary but enable it if we
            // run into strange bugs where the canvas does not match the
            // properties on the control after initial activation. I.e.
            // the defaults are different on newBackground than on old.
            //lp.pom.NewBGPropsHelper.syncModel(e.model);
            self.bindBackgroundControlsToElement(element);
          }
          if (e.type === 'setProperty' && e.property === 'fitWidthToPage') {
            // fitWidthToPage also affects border props
            self.bindBorderControlsToElement(element);
          }

        });

      this._bgUIBinding.subscribe(function(e) {
        // TODO: replace with dispatch table passed to _mkUIBinding above
        if(_.contains(_propertyTypes, e.property)){
          self._handleBackgroundPropertyChange(e);
        } else if (e.type === 'selectBackgroundType' || e.type === 'cancelBackgroundTypeChange') {
          // selectBackgroundType and cancelBackgroundTypeChange are of the same shape
          self._handleBackgroundStyleChange(e);
        } else if (e.type === 'toggleAdvancedBackgroundProperties') {
          var $advancedContainer = jQuery('#editor-info-panel .advanced-bg-props-container')
            , $advancedToggle = jQuery('#editor-info-panel .bg-panel-advanced')
            , element = window.editor.page.getElementById(e.elementId);

          $advancedContainer.toggle();
          $advancedToggle.toggleClass('advanced-panel-open');
          element.showAdvanced = $advancedContainer.is(':visible');
        }
      });

    },

    _handleBackgroundPropertyChange: function(e){
      //TODO:  look up the element by passed in id,
      //       not by side-effect of being active element
      var element  = this.element;

      // This extra step is needed to fix a race condition.
      // Ref : 7d54a5ff5698d508f347dc82179aa7eb66617f1b
      var model    = element.model;
      var changefn = _.partial(model.setNewBackgroundProp.bind(model), e.style);

      this.um.startGroup();
      this._changingBackground = true;
      changefn(e.property, e.value);
      this._changingBackground = false;
      this.um.endGroup();

      if ( ! e.skipRedraw) {
        this.bindBackgroundControlsToElement(element);
      }
    },

    _handleBackgroundStyleChange: function(ev) {
      //TODO:  look up the element by passed in id,
      //       not by side-effect of being active element
      var element = this.element;
      element.showAdvanced = false;
      this.um.startGroup();
      this._changingBackground = true;
      element.model.setNewBackgroundStyleType(ev.value);
      this._changingBackground = false;
      this.um.endGroup();

      var self = this;

      // If the user switches to image or pattern and doesn't have an image selected, show
      // the image chooser immediately
      if ((ev.value === 'image' || ev.value === 'pattern') &&
      _.isNull(window.lp.pom.NewBGPropsHelper.getProperties(this.element.model).image)) {
        var onchange = this._getOnchangeFn(ev.value);
        var onCancel = function() {
          // If the user cancels the dialog, revert to the previous background. But if the
          // previous type is image or pattern, reverting to that will cause the dialog to
          // be shown again, so in that case we do nothing.
          if (ev.previousValue !== 'image' && ev.previousValue !== 'pattern') {
            self._bgUIBinding.onNext({
              type          : 'cancelBackgroundTypeChange',
              property      : ev.property,
              value         : ev.previousValue,
              skipRedraw    : Boolean(ev.skipRedraw),
              elementId     : ev.elementId
            });
          }
        };

        _openImageChooser(onchange, onCancel);
      }

      this.bindBackgroundControlsToElement(element);
    },

    bindBackgroundControlsToElement: function(elm) {
      this._changingBackground = true;
      var props = elm.model.getNewBackgroundProperties();
      //TODO: RM THIS next line. It does not appear necessary
      //this.element.model.setNewBackgroundStyleType(props.style);
      this._renderBackgroundProps(props.style, props);
      this._changingBackground = false;
    },

    _isVideoBackgroundsAllowed: function() {
      var isEnabled = this.element.page.getConfigValue('allowVideoBackgrounds');

      return isEnabled && _.contains(['lp-pom-block', 'lp-pom-root'], this.element.type);
    },

    _renderBackgroundProps: function(style, props){
      var renderFn = bgControlRenderers[style];
      if(typeof renderFn !== 'function') {
        throw new Error('Invalid background style: ' + style);
      }
       var self = this;

      var backgroundPropsContainer = this.controls.backgroundPropsContainer;
      backgroundPropsContainer.clear();

      var selectOptions = [
        {name : 'Image'       , value : 'image'},
        {name : 'Pattern'     , value : 'pattern'},
        {name : 'Solid Color' , value : 'solidColor'},
        {name : 'Gradient'    , value : 'gradient'}
      ];

      if (this._isVideoBackgroundsAllowed()) {
        selectOptions.push({name : 'Video', value : 'video'});
      }

      this.controls.backgroundStyle = backgroundPropsContainer.insert(
        new jui.FormSelect ({
          label             : 'Style',
          width             : '120px',
          id                : 'bg-style-type-select',
          dropDownClassName : 'editor-info-panel-select jui-drop-down',
          autoWidth         : true,
          selectOptions     : selectOptions,
          action: function(e) {
            self._bgUIBinding.onNext({
              type          : 'selectBackgroundType',
              property      : e.type, // convert from dom type to rxUi
              value         : e.data,
              previousValue : window.lp.pom.NewBGPropsHelper.getStyleType(self.element),
              skipRedraw    : Boolean(e.skipRedraw),
              elementId     : self.element.id
            });
          }
        })
      );
      if (this.controls.backgroundStyle.getValue() !== style) {
        this.controls.backgroundStyle.select.setValue(style);
      }
      this.controls.backgroundProps = backgroundPropsContainer;

      renderFn(this.controls.backgroundProps, props, this._getOnchangeFn(style), this.element);
    },

    _getOnchangeFn: function(style) {
      var self = this;
      return function wrappedBackgroundChangeCallback(e) {
        var eventParams = {
          skipRedraw : Boolean(e.skipRedraw),
          style      : style,
          elementId  : self.element.id
        };

        // Only add these params to the event if they have a value
        _.forEach(['type', 'property', 'value'], function(param) {
          if (! _.isUndefined(e[param])) {
            eventParams[param] = e[param];
          }
        });

        self._bgUIBinding.onNext(eventParams);
      };
    }

  };
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/editor/panel/element_background_controls_flat.js
// module id = 1041
// module chunks = 0